module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_404", [["div",{"class":"layout-width"},[["div",{"class":"page-title","data-fox-alias":"1","data-fox-context":"promo_404"},[["textNode",{"text":"Looks like this page doesn't exist."}]]]]],["div",{"class":"img-404"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/404.tpl
// module id = 30
// module chunks = 2